import { orchestrator } from 'satcheljs';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { manageAdsOptions, acceptTargetedAds } from '../actions/internalActions';

orchestrator(manageAdsOptions, () => {
    // Before we pop out the option, we save all accepted values which match to what the user will see in the option
    // Even if the user chooses to dismiss the option later, the all accepted values will be saved.
    // If the user de-selects some options and save it later, the option will honor whatever he saves later
    acceptTargetedAds();
    lazyMountAndShowFullOptions.importAndExecute('general', 'advertising');
});
